import { Components, Theme } from '@mui/material/styles';

export const MuiDialogTitle: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      font: 'var(--font-h4)',
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(4),
      paddingInline: theme.spacing(4),

      '&:last-child': {
        paddingBottom: theme.spacing(6),
      },
    }),
  },
};
